/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import "./styles.m.css";

export const InvalidLink = ({ message = "You do not have the necessary access to view this page." }) => {
  return (
    <div styleName="content-wrapper">
      <div>{message}</div>
    </div>
  );
};
